/*
 * @Auther: 罗耀祖
 * @Date: 2022-04-20 16:43:45
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 16:45:57
 * @name: 登录手机号缓存
 * @Description: 登录手机号缓存
 * @FilePath: \project\src\storage\loginTelephone.storage.js
 * @Author: desktop
 */
import localstorage from "./localstorage";
class loginTelephoneStorage extends localstorage {
  constructor() {
    super();
    this.loginTelephone = this.getLoginTelephone();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取登录手机号缓存
   * @return {String} loginTelephone
   */
  getLoginTelephone() {
    return super.get('loginTelephone');
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 设置登录手机号缓存
   */
  setLoginTelephone(loginTelephone) {
    super.set('loginTelephone', loginTelephone);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 移除登录手机号缓存
   */
  removeLoginTelephone() {
    super.remove('loginTelephone');
  }
}
export default loginTelephoneStorage;